<template>
    <div >
        <div class="subscribePart">
            <h3 class="title">{{$t('homepage.lock_plan_title')}}</h3>
            <div class="content">
                <div class="left">
                    {{ $t('subscribe.planChooseTitle') }}
                </div>
                <div class="right">
                    <div class="right-content">
                        <reo-link
                            :text="$t('subscribe.traffic.help_me_choose')"
                            @click="handleDialogClick"
                            class='text-link countryBtn'
                            :class='[{"switchingLegacy":switchingLegacy}]'
                            :size="16"
                        />
                    </div>
                </div>
            </div>
        </div>

        <slot name="legacyTips"></slot>
        <div class="select-tab">
            <duration-tab
                v-if="durationList.length>0"
                :durationList="durationList"
                :activeDurationIndex="currentDeviceGroup"
                :yearPlansMaxDiscount="yearPlansMaxDiscount"
                align="center"
                @change="handleDurationChange"
            />
        </div>

        <help-plan-choose-dialog
            v-if="showPlanDescDialog"
            :isSim="false"
            :country='selectedCountry'
            :type="[ESeriesCategory.CLOUD_STORAGE_DATA_PLAN,ESeriesCategory.CLOUD_DATA_PLAN]"
            @cancel="handleDialogClick"
        ></help-plan-choose-dialog>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { config } from 'CONFIG';
import { isInVisibleArea, valueWithFallbacks } from '@/common/js/utils';
import { IDuration, IPlan, IPlanSeries, ISelectorStyle } from '@reolink-cloud/interface';
import IconCountry from '@/common/images/common/combo/co_web.svg';
import ReoLink from '@/basic/Link.vue';
import { countriesManager } from '@/lib';
import { IDeviceGroupWithPlans } from '@/view/reolink/homepage/lib/types';
import * as _ from '@reolink-web/utils';
import { mapGetters } from 'vuex';
import HelpPlanChooseDialog from '@/components/Dialogs/HelpPlanChooseDialog.vue';
import { ESeriesCategory } from '@/interface';
import DurationTab from '@/components/DurationTab.vue';

interface ISeriesItem extends IPlanSeries {
    plans: IPlan[];
}

export default Vue.extend({
    components: {
        DurationTab,
        HelpPlanChooseDialog,
        ReoLink
    },
    props: {
        storageLocList: Object,
        cloudProductLists: Object,
        switchingLegacy: {
            type: Boolean,
            default: false
        },
        dataPlanSeries: Array as PropType<ISeriesItem[]>,
        durationList: Array as PropType<IDuration[]>
    },
    data () {

        return {
            config,
            deviceList: [] as any[],
            showSubscription: false,
            showAvailableCountries: false,
            isEurope: false,
            locations: [] as any[],
            locationIndex: 0,
            supportedCountryList: [] as any[],
            deviceGroupDes: '',
            currentDeviceGroup: 0,
            supportedDeviceList: [] as any[],
            locationKey: this.$route.query.loc,
            modelKey: this.$route.query.model || '',
            dialogStack: [] as any[],
            planNoticeText: '',
            showAvailableDevices: false,
            isSubPage: false,
            isNewSubPage: false,
            defaultSelected: '',
            scrollHandleEnable: false,
            mobileSubBtnShow: false,
            showPlanDescDialog: false,
            selectedCountry: 'US',
            IconCountry,
            ESeriesCategory,
        };

    },
    created () {

        this.isSubPage = window.location.href.includes( 'plan' );
        this.isNewSubPage = window.location.href.includes( 'subscribe-plan' );

    },
    computed: {
        ...mapGetters( ['country'] as const ),
        isShowTitle (): boolean {

            return ( this.isMobile || window.location.href.includes( 'subscribe' )) && !window.location.href.includes( 'update' );

        },
        userStatus (): string {

            return this.$store.state.user.status;

        },
        selectorStyle (): ISelectorStyle {

            return !this.isMobile ? {
                widthOut: 3,
                heightOut: 0.48,
                widthIn: 3,
                heightIn: 0.48,
                selectMarginLeft: 0.16,
                triangleRight: 0.16,
                maxHeight: 3.08,
                fontSizeIn: 0.14,
                fontSizeOut: 0.16
            } : {
                widthOut: -1,
                heightOut: 0.48,
                widthIn: -1,
                heightIn: 0.4,
                selectMarginLeft: 0.16,
                triangleRight: 0.16,
                maxHeight: 4.8,
                fontSizeIn: 0.16,
                fontSizeOut: 0.14
            };

        },
        defaultStorageRegion (): Record<string, any> {

            return this.cloudProductLists.defaultStorageRegion;

        },
        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        defaultCountry(): string {

            return countriesManager.getSingleCountryInfo(
                valueWithFallbacks( this.country, this.cloudProductLists.country, config.fallbackCountry )
            ).name;

        },
        yearPlansMaxDiscount(): string | undefined {

            const planSeriesList: ISeriesItem[] = Object.values( this.storageLocList[this.locations[0].value]?.planSeries ?? {});
            const maxDiscount = Math.max( ...planSeriesList.map(( series: ISeriesItem ) => Math.max( ...series.plans.filter(( plan: IPlan ) => plan.duration.unit === 'year' )
                .map(( plan: IPlan ) => {

                    const regularPrice = parseFloat( plan.pricing.regularPrice );
                    if ( regularPrice === 0 ) {

                        return 0;

                    } else {

                        return 100 - 100 * parseFloat( plan.pricing.salePrice ) / parseFloat( plan.pricing.regularPrice );

                    }

                }))),
            0 );
            return maxDiscount >= 1 ? this.$t( 'plan.discount_up_to', {
                discount: maxDiscount.toFixed( 0 )
            }).toString() : undefined;

        }
    },
    methods: {
        handleDialogClick(): void {

            this.showPlanDescDialog = !this.showPlanDescDialog;

        },

        scrollHandle ( ): false | undefined {

            if ( !this.scrollHandleEnable ) {

                return false;

            }
            this.scrollHandleEnable = false;
            setTimeout(() => {

                if ( $( 'body' ).eq( 0 )[ 0 ].offsetWidth < 1200 ) {

                    this.calcPlanIsInWindow( );

                }
                this.scrollHandleEnable = true;

            }, 100 );

        },
        calcPlanIsInWindow ( ): void {

            let visible = isInVisibleArea( '#plans-select' );
            this.mobileSubBtnShow = visible;

        },
        // 机型组切换
        handleDurationChange ( val ): void {

            this.currentDeviceGroup = val;
            this.deviceGroupDes = this.durationList[val].des;
            this.$emit( 'changeDuration', this.durationList[val] );

        },
        // 存储地切换
        handleLocationChange ( val ): void {

            this.supportedCountryList = _.Array.unique( Object.values<any>( this.storageLocList ).map( loc => loc.supportedCountryList ).flat(), item => item.code );
            let list: any[] = [];
            const dataStorageSeries: ISeriesItem[] = Object.values( this.storageLocList[val]?.planSeries ?? {});
            const allSeries = ( this.dataPlanSeries ?? [] ).concat( dataStorageSeries );
            for ( const seriesItem of allSeries ) {

                for ( const planItem of ( seriesItem.plans ?? [] )) {

                    const amount = planItem.duration.amount;
                    const unit = planItem.duration.unit;
                    const key = `${amount}-${unit}`;
                    if ( !list.some( item => item.key === key ) && !planItem.seriesKey.includes( 'basic' )) {

                        list.push({
                            key,
                            title: this.$tc( `cycle.${unit}`, amount === 1 ? 1 : 0, { count: amount }),
                            id: key,
                            amount,
                            unit
                        });

                    }

                }

            }
            const unitToOrder = {
                year: 4,
                month: 3,
                week:2,
                day: 1
            };
            list = list.sort(( a, b ) => {

                if ( a.unit === b.unit ) {

                    return a.amount - b.amount;

                } else {

                    return unitToOrder[a.unit] - unitToOrder[b.unit];

                }

            });
            this.defaultSelected = val;

            const basicSerials = ( Object.values( this.storageLocList[val]?.deviceGroupsList ?? {}) as IDeviceGroupWithPlans[] ).map( item => item.basicSerial ).filter( item => item !== undefined );
            this.$emit( 'changeSelect', { list: list, locationKey: val, basicSerial: basicSerials[0], supportedDeviceList: this.supportedDeviceList, supportedCountryList: this.supportedCountryList });
            if ( this.isShowTitle ) {

                this.planNoticeText = typeof this.cloudProductLists.storageRegions[val].i18n.note !== 'undefined' ? this.cloudProductLists.storageRegions[val].i18n.note : '';

            }

        },
        handleProductOrLocChange(): void {

            const newVal = this.storageLocList;

            if ( typeof newVal === 'undefined' || JSON.stringify( newVal ) === '{}' ) {

                return;

            }
            let regionsData = this.cloudProductLists.storageRegions;
            Object.keys( newVal ).map(( loc ) => {

                if ( loc === this.defaultStorageRegion.loc ) {

                    return;

                }
                this.locations.push({
                    'label': regionsData[loc].i18n.name,
                    'value': regionsData[loc].key,
                    'key': regionsData[loc].key,
                    id: regionsData[loc].key,
                    'sortOrder': regionsData[loc].sortOrder
                });

            });
            this.locations = this.locations.sort(( a, b ) => a.sortOrder - b.sortOrder );
            if ( JSON.stringify( this.defaultStorageRegion ) !== '{}' ) {

                this.locations.unshift({
                    'label': this.defaultStorageRegion.i18n.name,
                    'value': this.defaultStorageRegion.loc,
                    'key': this.defaultStorageRegion.loc,
                    'sortOrder': this.defaultStorageRegion.sortOrder,
                    id: this.defaultStorageRegion.loc
                });
                this.defaultSelected = this.locations[0].value;
                this.handleLocationChange( this.locations[0].value );

            }

            if ( this.modelKey !== '' ) {

                this.$nextTick(() => {

                    for ( const [index, item] of Object.entries( this.durationList )) {

                        if ( item.key === this.modelKey && this.currentDeviceGroup !== Number( index )) {

                            this.$nextTick(() => {

                                this.handleDurationChange( Number( index ));

                            });

                        }

                    }

                });

            }

            if ( window.location.href.includes( '#showAvailableCountries' )) {

                document.getElementsByName( 'subscribe' )[0].scrollIntoView();
                this.showAvailableCountries = true;

            }

        }

    },
    watch: {
        storageLocList: {
            handler () {

                this.handleProductOrLocChange();

            },
            immediate: true
        },
        cloudProductLists: {
            handler() {

                this.handleProductOrLocChange();

            },
            immediate: true,
            deep: true
        },
        supportedCountryList ( val ): void {

            this.supportedCountryList = val;

        }
    }
});
</script>

<style scoped rel="stylesheet/css" lang="less">

::-webkit-scrollbar{
    width: 4px;
    height: 4px;
}
::-webkit-scrollbar-thumb{
    background-color: #CCCCCC;
    border-radius: 8px;
}
.subscribePart{
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;
    .mobile({
        padding: 20px 0;
    });

    .title-container {
        background-color: white;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .title {
        font-weight: bold;
        color: #333;
        font-size: 42px;
        line-height: 1.2;
        margin-bottom: 24px;
        padding-top: 40px;
        text-align: center;
    }

    .content {
        display: flex;
        justify-content: space-between;
        width: 100%;
        flex-wrap: wrap;
        align-items: flex-end;
    }

    .left, .right {
        margin: 5px;
    }

    .left {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        font-size: 20px;
        font-weight: 600
    }
    .help-me-choose {
        .text-hover();
        font-size: 16px;
        font-weight: 500;
        flex-shrink: 0;
    }

    .left-title {
        margin-bottom: 5px;
        font-size: 16px;
        font-weight: 600;
    }

    .left-content, .right-content {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .left-content span, .right-content span {
        display: inline-block;
        margin-right: 5px;
        flex: 1;
    }

    .left-content i, .right-content i {
        display: inline-block;
        margin-left: 5px;
        justify-content: flex-start;
    }

    .countryBtnBox{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 4px;
        @media @pc{
            &.switchingLegacy{
                margin-bottom: 0rem;
            }
        }
        .mobile({
            flex-wrap: wrap;
        });
        .country-text{
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            align-items: center;
            gap: 4px;
            min-width: 0;
            img{
                vertical-align: text-bottom;
            }
            .mobile({
                margin-bottom: 4px;
            });
        }
    }
}

@media (max-width: 600px) {
    .subscribePart{
        .content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }

        .left, .right {
            flex: auto;
        }

        .left-content, .right-content {
            justify-content: flex-start;
        }
    }
}
/*清除ie的默认选择框样式清除，隐藏下拉箭头*/
.subscribePart select::-ms-expand { display: none; }

.subscribePart input::-webkit-input-placeholder,
.subscribePart input::-moz-placeholder {
    color: #ccc;
}

.smallMargin{
    @media @pc{
        margin-bottom: .16rem !important;
    }
}
.select-tab{
    display: flex;
    justify-content: center;
}
</style>
